import { getSocket } from '@/hooks/useRealtimeSync';

const pendingAckIds = new Set<string>();
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function flushDeliveryAcks(): void {
  flushTimer = null;
  if (pendingAckIds.size === 0) return;
  const messageIds = [...pendingAckIds];
  pendingAckIds.clear();
  try {
    getSocket().emit('messenger:delivery_ack', { messageIds });
  } catch {
    for (const id of messageIds) pendingAckIds.add(id);
  }
}

/** Queue delivery ack for incoming messages (batched). */
export function ackMessengerDelivery(messageIds: string | string[]): void {
  const ids = Array.isArray(messageIds) ? messageIds : [messageIds];
  for (const id of ids) {
    const t = typeof id === 'string' ? id.trim() : '';
    if (t) pendingAckIds.add(t);
  }
  if (pendingAckIds.size === 0) return;
  if (flushTimer != null) return;
  flushTimer = setTimeout(flushDeliveryAcks, 50);
}

/** Flush immediately (reconnect / visibility). */
export function flushMessengerDeliveryAcks(): void {
  if (flushTimer != null) {
    clearTimeout(flushTimer);
    flushTimer = null;
  }
  flushDeliveryAcks();
}
